/* Industrialsafety-UK product page: help rows + quote dialog (v1 2-10-2026, v2 3-10-2026: live product state, field validation, input kept on errors) */
(function () {
  'use strict';
  var root = document.querySelector('[data-isu-pdp]');
  var help = document.querySelector('[data-isu-help]');
  var dlg = document.getElementById('isu-quote');
  var qty = document.querySelector('[data-isu-qty]');
  var state = { qty: qty ? parseInt(qty.value, 10) || 1 : 1, title: '', sku: '', price: '', unit: '', mode: root ? root.getAttribute('data-unit-mode') : '' };
  if (root) root.addEventListener('isu:state', function (e) { for (var k in e.detail) state[k] = e.detail[k]; });
  var pull = function () { if (root && root.isuState) for (var k in root.isuState) state[k] = root.isuState[k]; };

  /* email link: product, size, grade, option, amount and link in the body */
  if (help) {
    var mail = help.querySelector('[data-isu-mail]');
    if (mail) {
      mail.addEventListener('click', function () {
        pull();
        var d = help.dataset, lines = ['Product: ' + d.title];
        if (d.size) lines.push('Size: ' + d.size);
        if (d.grade) lines.push('Grade: ' + d.grade);
        if (state.title && state.title !== 'Default Title') lines.push('Option: ' + state.title);
        if (state.sku) lines.push('SKU: ' + state.sku);
        lines.push(state.mode === 'metre' ? 'Length: ' + state.qty + ' m' : 'Quantity: ' + state.qty);
        lines.push('Link: ' + d.url, '', '');
        mail.href = 'mailto:' + d.email + '?subject=' + encodeURIComponent('Enquiry: ' + d.title) + '&body=' + encodeURIComponent(lines.join('\n'));
      });
    }
  }
  if (!dlg) return;

  var form = dlg.querySelector('form');
  var KEY = 'isu-quote-draft:' + location.pathname;
  var saved = function () { return Array.prototype.slice.call(dlg.querySelectorAll('[data-isu-qsave]')); };
  var save = function () { try { var o = {}; saved().forEach(function (f) { o[f.id] = f.value; }); sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
  var restore = function () { try { var o = JSON.parse(sessionStorage.getItem(KEY) || '{}'); saved().forEach(function (f) { if (o[f.id] && !f.value) f.value = o[f.id]; }); } catch (e) {} };
  var clear = function () { try { sessionStorage.removeItem(KEY); } catch (e) {} };

  /* field-level validation */
  var err = dlg.querySelector('[data-isu-qerr]');
  var check = function (el) {
    var e = document.getElementById(el.id + '-e');
    var v = (el.value || '').trim(), bad = !v || (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
    el.setAttribute('aria-invalid', bad ? 'true' : 'false');
    if (e) e.textContent = bad ? e.getAttribute('data-msg') : '';
    return !bad;
  };
  var req = form ? Array.prototype.slice.call(form.querySelectorAll('[required]')) : [];
  req.forEach(function (el) {
    el.addEventListener('blur', function () { if (el.value) check(el); });
    el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') check(el); });
  });
  var validate = function () {
    var bad = req.filter(function (el) { return !check(el); });
    if (err) {
      err.hidden = !bad.length;
      err.textContent = bad.length ? (bad.length === 1 ? 'Please fix 1 field below.' : 'Please fix ' + bad.length + ' fields below.') : '';
    }
    if (bad.length) bad[0].focus();
    return !bad.length;
  };
  var send = dlg.querySelector('[data-isu-qsend]');
  if (send) send.addEventListener('click', function (e) { if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); } else save(); });
  if (form) form.addEventListener('submit', function (e) { if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); } else save(); }, true);

  var opener = null;
  var sync = function () {
    if (root && root.isuState) for (var k in root.isuState) state[k] = root.isuState[k];
    var q = dlg.querySelector('[data-isu-qqty]');
    if (q && qty) q.value = parseInt(qty.value, 10) || 1;
    var vf = dlg.querySelector('[data-isu-qvariant]');
    if (vf && state.title) vf.value = state.title + (state.sku ? ' (' + state.sku + ')' : '');
    var vl = dlg.querySelector('[data-isu-qvlabel]');
    if (vl && state.title && state.title !== 'Default Title') { vl.hidden = false; vl.textContent = state.title; }
    var pc = dlg.querySelector('[data-isu-qpricechip]');
    if (pc && state.price) pc.textContent = state.price + ' ' + state.unit;
    var pf = dlg.querySelector('[data-isu-qprice]');
    if (pf && state.price) pf.value = state.price + ' ' + state.unit;
  };
  function open(e) {
    if (e) e.preventDefault();
    opener = e && e.currentTarget ? e.currentTarget : document.activeElement;
    sync();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    isOpen = true;
    document.documentElement.classList.add('isu-qd-open');
    document.dispatchEvent(new CustomEvent('isu:dialog'));
    var first = dlg.querySelector('[data-isu-qstatus][tabindex]') || dlg.querySelector('[aria-invalid="true"]') || dlg.querySelector('textarea, input:not([type="hidden"])');
    if (first) first.focus();
  }
  var isOpen = false;
  function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); onClose(); }
  function onClose() {
    if (!isOpen || dlg.open) return;
    isOpen = false;
    document.documentElement.classList.remove('isu-qd-open');
    document.dispatchEvent(new CustomEvent('isu:dialog'));
    if (opener && opener.focus && document.contains(opener)) opener.focus();
  }
  /* the theme's dialog handling doesn't always fire "close", so also watch the open attribute and Escape */
  dlg.addEventListener('close', onClose);
  if ('MutationObserver' in window) new MutationObserver(function () { if (!dlg.open) onClose(); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
  document.querySelectorAll('[data-isu-qopen]').forEach(function (b) { b.addEventListener('click', open); });
  dlg.querySelectorAll('[data-isu-qclose]').forEach(function (b) { b.addEventListener('click', close); });
  dlg.addEventListener('click', function (e) {
    var r = dlg.getBoundingClientRect();
    if (e.target === dlg && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) close();
  });

  /* after sending, the page reloads with the result: show it (and keep what was typed if it failed) */
  if (dlg.querySelector('.isu-ok')) clear();
  if (err && !err.hidden) restore();
  if (dlg.querySelector('[data-isu-qstatus]')) open();
  else if (window.location.hash === '#isu-quote') open();
})();
